import script from "./AddressLine.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressLine.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__